// Lightweight i18n dictionary for ID/EN
export const DICT = {
  id: {
    appTitle: 'Moodle Generator Questions (XML Format)',
    videoTutorial: 'video tutorial',
    quizTitle: 'Judul Quiz:',
    quizTitlePh: 'Masukkan judul quiz',
    panduan: 'Panduan',
    preview: 'Preview',
    downloadXml: 'Download XML',
    exportPdf: 'Export PDF',
    exportDocx: 'Export DOCX',
    import: 'Import',
    history: 'Riwayat',
    saveDraft: 'Simpan Draft',
    new: 'New',
    questionTitle: 'Judul Soal:',
    question: 'Pertanyaan:',
    questionPh: 'Tulis pertanyaan di sini...',
    option: 'Pilihan',
    optionPh: 'Teks pilihan jawaban',
    correctAnswer: 'Jawaban Benar:',
    trueText: 'Benar',
    falseText: 'Salah',
    answer: 'Jawaban',
    answerPh: 'Tulis jawaban benar',
    addAnswer: '+ Tambah jawaban',
    numAnswer: 'Nilai jawaban',
    tolerance: 'Toleransi',
    matchQ: 'Pertanyaan',
    matchA: 'Jawaban',
    addPair: '+ Tambah pasangan',
    sampleAnswer: 'Contoh jawaban (opsional):',
    insertImage: 'Insert link Image',
    insertVideo: 'Insert link Video',
    delete: 'Hapus',
    close: 'Tutup',
    startExam: 'Mulai Mode Ujian',
    submitExam: 'Kumpulkan Jawaban',
    yourScore: 'Skor Anda',
    correct: 'Benar',
    incorrect: 'Salah',
    noQuestions: 'Belum ada soal. Pilih tipe soal di sidebar untuk mulai.',
    importTitle: 'Import Soal dari File',
    importCsvHint: 'CSV: kolom type,question,option1..5,correct',
    importDocxHint: 'DOCX: soal dipisah baris kosong, pilihan diawali A. B. C. …, jawaban ditandai *',
    selectFile: 'Pilih File',
    importBtn: 'Import',
    historyTitle: 'Riwayat Kuis',
    empty: '(kosong)',
    load: 'Muat',
    save: 'Simpan',
    savedAt: 'Disimpan',
    confirmDelete: 'Yakin hapus?',
    downloadTemplate: 'Unduh Template CSV',
    panduanTitle: 'Panduan Penggunaan',
    cancel: 'Batal',
    confirmClearTitle: 'Bersihkan semua soal?',
    confirmClearDesc: 'Semua soal yang belum disimpan akan hilang. Tindakan ini tidak bisa dibatalkan.',
    confirmClearAction: 'Ya, bersihkan',
    confirmDeleteTitle: 'Hapus draft ini?',
    confirmDeleteDesc: 'Draft yang dihapus tidak bisa dikembalikan.',
    confirmDeleteAction: 'Ya, hapus',
    draftSavedTitle: 'Draft tersimpan',
    draftSavedDesc: 'Draft berhasil disimpan ke riwayat.',
    insertImageTitle: 'Sisipkan gambar',
    insertImagePh: 'https://contoh.com/gambar.png',
    insertVideoTitle: 'Sisipkan video',
    insertVideoPh: 'https://youtube.com/... atau .mp4',
    insertAction: 'Sisipkan',
  },
  en: {
    appTitle: 'Moodle Generator Questions (XML Format)',
    videoTutorial: 'video tutorial',
    quizTitle: 'Quiz Title:',
    quizTitlePh: 'Enter quiz title',
    panduan: 'Guide',
    preview: 'Preview',
    downloadXml: 'Download XML',
    exportPdf: 'Export PDF',
    exportDocx: 'Export DOCX',
    import: 'Import',
    history: 'History',
    saveDraft: 'Save Draft',
    new: 'New',
    questionTitle: 'Question Title:',
    question: 'Question:',
    questionPh: 'Write your question here...',
    option: 'Option',
    optionPh: 'Answer option text',
    correctAnswer: 'Correct Answer:',
    trueText: 'True',
    falseText: 'False',
    answer: 'Answer',
    answerPh: 'Write correct answer',
    addAnswer: '+ Add answer',
    numAnswer: 'Numeric answer',
    tolerance: 'Tolerance',
    matchQ: 'Question',
    matchA: 'Answer',
    addPair: '+ Add pair',
    sampleAnswer: 'Sample answer (optional):',
    insertImage: 'Insert Image link',
    insertVideo: 'Insert Video link',
    delete: 'Delete',
    close: 'Close',
    startExam: 'Start Exam Mode',
    submitExam: 'Submit Answers',
    yourScore: 'Your Score',
    correct: 'Correct',
    incorrect: 'Incorrect',
    noQuestions: 'No questions yet. Pick a question type in the sidebar to start.',
    importTitle: 'Import Questions from File',
    importCsvHint: 'CSV columns: type,question,option1..5,correct',
    importDocxHint: 'DOCX: separate questions with blank line, options as A. B. C. …, mark correct with *',
    selectFile: 'Select File',
    importBtn: 'Import',
    historyTitle: 'Quiz History',
    empty: '(empty)',
    load: 'Load',
    save: 'Save',
    savedAt: 'Saved',
    confirmDelete: 'Delete?',
    downloadTemplate: 'Download CSV Template',
    panduanTitle: 'User Guide',
    cancel: 'Cancel',
    confirmClearTitle: 'Clear all questions?',
    confirmClearDesc: 'All unsaved questions will be lost. This action cannot be undone.',
    confirmClearAction: 'Yes, clear',
    confirmDeleteTitle: 'Delete this draft?',
    confirmDeleteDesc: 'A deleted draft cannot be recovered.',
    confirmDeleteAction: 'Yes, delete',
    draftSavedTitle: 'Draft saved',
    draftSavedDesc: 'Your draft was saved to history.',
    insertImageTitle: 'Insert image',
    insertImagePh: 'https://example.com/image.png',
    insertVideoTitle: 'Insert video',
    insertVideoPh: 'https://youtube.com/... or .mp4',
    insertAction: 'Insert',
  },
};

export const t = (key, lang = 'id') => (DICT[lang] && DICT[lang][key]) || key;
